var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('headerView'),_c('div',{staticClass:"routerDiv"},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1),(!_vm.cookieShow)?_c('cookie',{staticClass:"indexCookie"}):_vm._e(),_c('SiteMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }